import Image from "components/Image"
import Link from "next/link"
import { stripHtmlSpaces } from "utils/strip-html-spaces"
import styles from "./BlogListItem.module.scss"
import cn from "classnames"
import moment from "moment"
import LinkButton from "components/ui/LinkButton"

export const BlogListItem = ({ headlineItemType, item, content }) => {
  const HeadlineItemType = headlineItemType
  const { title_image: titleImage, teaser, title, url, publish_date } = item

  const formattedPublishDate = publish_date
    ? moment(publish_date).locale("de").format("DD. MMMM Y")
    : null

  return (
    <div
      className={cn(styles.item, {
        [styles[`item--${content.locale}`]]: content.locale,
      })}
    >
      <Link href={url}>
        <a>
          <div className={styles.image}>
            {titleImage && titleImage.is_image && (
              <Image
                src={titleImage.permalink}
                alt={titleImage?.alt}
                width={titleImage.width}
                height={titleImage.height}
                sizes="(max-width: 767px) 100vw, 50vw"
                style={{ objectPosition: titleImage.focus_css }}
              />
            )}
          </div>
          <div className={styles.content}>
            <div className={styles.bg} aria-hidden />
            {/* {formattedPublishDate && (
              <p className={styles.headlineTeaser}>{formattedPublishDate}</p>
            )}*/}
            <HeadlineItemType className={`h4 ${styles.headline}`}>
              {title}
            </HeadlineItemType>
            <p className={styles.description}>{stripHtmlSpaces(teaser)}</p>
          </div>
          <LinkButton
            data={{
              link_text: "Weiterlesen",
              show_arrow: true,
            }}
            className={styles.button}
          />
        </a>
      </Link>
    </div>
  )
}
